/*
 Author : Jerome Martin


 Markup :
 <article data-vel-content-type="article" data-vel-content-id="8188" data-vel-content-title="Comment le Vélib' a relancé le vélo" data-date="2014-01-14" >
 <a href="javascript:void(0);" class="js-vel-button" data-vel-type="service" data-vel-id="12053" data-vel-priceid="11616" data-vel-tunnelimage="<img_sp_style=_qq_display:_sp_inline_qq__sp_alt=_qq_La_sp_une_sp_de_sp_L_qt_Équipe_sp_-_sp_lundi_sp_16_sp_juin_qq__sp_width=_qq_298_qq__sp_height=_qq_440_qq_>" rel="nofollow">Je m'abonne</a>
 </article>

 Setup :

 $(function() {
 $("article").vel();
 });
 */
;
(function ($, window, document, undefined) {
    "use strict";

    var pluginName = "vel",
        defaults = {
            contentProductType: "journalff",
            contentProductName: "France Football",
            processAction: "buyArticle",
            buyButton: '.js-vel-button',
            cookieName: 'vel_context',
            cookieExpires :"",
            connexionUrl: '/mon-compte/abonnement-numerique/inscription',
            ePaymentUrl: $('meta[property="mpp:ePaymentUrl"]').attr("content")

        };

    function Plugin(element, options) {
        this.element = element;
        this.settings = $.extend({}, defaults, options);
        this._defaults = defaults;
        this._name = pluginName;
        this.init();
    }

    $.extend(Plugin.prototype, {
        init: function () {
            this.datas = {"offer": {}, "content": {}};
            if (this.settings.connexionUrl == document.location.pathname)
                this.setDatasFromCookie();
            this.setEvents();
        },

        setDatasFromCookie: function () {
            var cookie = $.cookie(this.settings.cookieName);
            var datas = {};
            if (cookie){
                this.datas = JSON.parse(cookie);
            } else{
                //si pas de cookie c'est que l'on a accédé directement au tunnel
                window.location.href="/";
            }
        },

        setDatasFromButton: function () {
            var pattNews= new RegExp("/news/");

            this.datas.offer['type'] = this.btnDatas.type;
            this.datas.offer['id'] = this.btnDatas.id;
            this.datas.offer['priceId'] = this.btnDatas.priceid;
            if (window.location.search.length > 0 && window.location.search.indexOf("prov") > -1) {
                this.datas.offer['provenance'] = window.location.search.split("&")[0].replace("?prov=","");
            }


            if (this.btnDatas.productid)
                this.datas.content['id'] = this.btnDatas.productid;
            if (this.btnDatas.productimg)
                this.datas.offer['tunnelImage'] = this.btnDatas.productimg;

            if(this.datas.offer['type'] == 'product')
            {
                if(typeof this.btnDatas.producttype != "undefined" && this.btnDatas.producttype!="" && this.btnDatas.producttype!=null ){
                    this.datas.content['type'] = this.btnDatas.producttype;
                }else{
                    this.datas.content['type'] = this.settings.contentProductType;
                }

                if(typeof this.btnDatas.productname != "undefined" && this.btnDatas.productname!="" && this.btnDatas.productname!=null ){
                    this.datas.content['name'] = this.btnDatas.productname;
                }else{
                    this.datas.content['name'] = this.settings.contentProductName;
                }


            }


            if (this.btnDatas.url) {
                this.datas.content['url'] = this.btnDatas.url;
                if (this.datas.content.url.indexOf("http") == -1) {
                    this.datas.content.url = document.location.origin + this.datas.content.url;
                }

            } else if(this.datas.content.type=='journalff'){
                this.datas.content.url = document.location.origin +"/liseuse/"+this.datas.content.id;
            }else if(pattNews.test(document.location.href)){
                this.datas.content['url'] = document.location.href;
            }else{
                this.datas.content['url'] = document.location.origin+"/";
            }
            this.datas.paymentMode='';
        },

        setEvents: function () {
            var that = this,
                el = this.element;

            $(document).on('click', that.settings.buyButton, function(e) {
                if ($(this).data('vel-datas')) {
                    that.btnDatas = $(this).data('vel-datas');
                    that.setDatasFromButton();
                    if (that.datas.offer) {
                        that.setCookie();
                        that.go();
                    }
                }
                e.preventDefault();
            });
        },

        setCookie: function () {
            var that = this;
            $.cookie(this.settings.cookieName, JSON.stringify(this.datas), {
                expires: that.settings.cookieExpires,
                domain: '.francefootball.fr',
                path: '/'
            });
        },

        go: function () {
            var that = this;
            if (connection.isLoggedIn() && connection.datas.magAbonne == 1 && that.datas.offer['type']=="service" ) {
                that.showMessage('error', 'Vous êtes déja Abonnée');
            } else if (connection.isLoggedIn() && typeof connection.datas.mpp != 'object') {
                that.syncMpp();
            } else if (connection.isLoggedIn() && connection.datas.mpp.buy_in_oneclick==1 ) {
                that.setConfirm({
                    message: "Confirmez-vous l'achat en un clic ?",
                    onConfirm: function() {
                        that.datas.paymentMode = 'oneClick';
                        that.goBuy();
                    },
                    onUnconfirm: function() {
                        that.datas.paymentMode = 'tunnel';
                        that.goBuy();
                    }
                });
            } else if (connection.isLoggedIn()) {
                that.goBuy();
            } else {
                that.goConnexion();
            }
        },

        goBuy: function () {
            var that = this;
            var url = $("meta[property='mpp:buy']").attr("content");
            that.showMessage("loader","Achat en cours ...");
            $.ajax({
                type: 'POST',
                url: url,
                dataType: 'json',
                data: {
                    offer: that.datas.offer,
                    content: that.datas.content,
                    processAction: that.settings.processAction,
                    paymentMode : that.datas.paymentMode
                },
                success: function (data) {
                    if(typeof data != "undefined")
                    {
                        if (data.error.errorCode == 0 && typeof data.error.customParams.guid!="undefined") {
                            var url = that.settings.ePaymentUrl + "?guid=" + data.error.customParams.guid;
                            document.location.href = url;
                        } else if(data.error.errorCode == 0 && data.error.customParams.succeed==1 ){
                            that.showMessage('success', "Merci de votre achat ,un email de confirmation va vous être envoyé");
                            that.setRedirectToUnloadPopin(data.error.customParams.returnurl);
                            /*setTimeout(function(){
                                document.location.href=data.error.customParams.returnUrl;
                            }, 5000);*/
                        } else {
                            var message="";
                            if(typeof data.error.customParams.succeedMsg != 'undefined') {
                                message = data.error.customParams.succeedMsg;
                            } else {
                                message = data.error.errorMessages;
                            }

                            that.showMessage('error', message);
                        }
                    }else{
                        that.showMessage('error',"Probleme lors de la transaction");
                    }

                }
            });
        },

        goConnexion: function () {
            var that = this;
            document.location.href = that.settings.connexionUrl;
        },

        syncMpp: function () {
            var that = this;
            var url = $("meta[property='mpp:sync']").attr("content");
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: {
                    method: 'registerMpp',
                    id: connection.datas.id,
                    cpte_email: connection.datas.email,
                    nom: connection.datas.lastname,
                    prenom: connection.datas.firstname
                },
                success: function (data) {
                    if (data == true) {
                        connection.getCookie();
                        that.go();
                    }
                }
            });
        },

        setRedirectToUnloadPopin : function(url){
            var that = this;
            if (popin) {
                popin.$popin.on('popin-unload', function () {
                    popin.$popin.off('popin-unload');
                    if(typeof url != 'undefined')
                    {
                        document.location.href=url;
                    }

                });
            }
        },

        showMessage: function (type, message) {
           if (popin && message) {
               if (type=='error') {
                   var html = '<div class="popin__head"><span class="popin__logo"></span></div><div class="popin__body">';
                   html += '<p class="paragraph"><span class="message message--error">' + message +'</span></p>';
                   html += '</div>';
                   popin.setPopin({
                       html: html,
                       classname: "popin popin--xs popin--auto"
                   });
               } else if(type=='success') {
                   var html = '<div class="popin__head"><span class="popin__logo"></span></div><div class="popin__body">';
                   html += '<p class="paragraph"><span class="message message--success">' + message +'</span></p>';
                   html += '</div>';
                   popin.setPopin({
                       html: html,
                       classname: "popin popin--toaster",
                       globalClassname: "is-toasting"
                   });
               } else if(type=="loader") {
                   var html = '<div class="popin__head"><span class="popin__logo"></span></div><div class="popin__body">';
                   html += '<p class="paragraph"><div class="loader is-loading"><span class="loader__icon"></span>' + message +'</div></p>';
                   html += '</div>';
                   popin.setPopin({
                       html: html,
                       classname: "popin popin--toaster",
                       globalClassname: "is-toasting"
                   });
               }
            }
        },

        setConfirm: function(params) {
            var html = '<div class="popin__head"><span class="popin__logo"></span></div><div class="popin__body">';
            html += '<p class="paragraph"><span class="message">' + params.message +'</span></p>';
            html += '<a href="#" class="button button--yes js-confirm-yes">Oui</a><a href="#" class="button button--no js-confirm-no">Non</a>';
            html += '</div>';
            popin.setPopin({
                html: html,
                classname: "popin popin--xs popin--auto popin--confirm"
            });
            $(".js-confirm-yes").one("click", function(e) {
                params.onConfirm();
                popin.unsetPopin();
                e.preventDefault();
            });
            $(".js-confirm-no").one("click", function(e) {
                params.onUnconfirm();
                popin.unsetPopin();
                e.preventDefault();
            });
        }

    });

    $.fn[pluginName] = function (options) {
        this.each(function () {
            if (!$.data(this, "plugin_" + pluginName)) {
                $.data(this, "plugin_" + pluginName, new Plugin(this, options));
            }
        });
        return this;
    };

})(jQuery, window, document);
